import { prosBrowseZoneCExperimentRowIndex } from '../constants/prosBrowseExperimentRowIndex';

export default function getBrowseZoneCRowIndex(isUSA, isWeddingRegistry) {
  const defaultRowIndex = prosBrowseZoneCExperimentRowIndex['670-22'];
  // if there are banners then increment row index
  return isUSA && !isWeddingRegistry ? defaultRowIndex + 2 : defaultRowIndex;
}
